var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.183 20.568A3.953 3.953 0 0 0 12 21a3.953 3.953 0 0 0 3.233-1.65c2.858-3.943 4.308-6.907 4.308-8.81a7.541 7.541 0 1 0-15.082 0c0 1.903 1.45 4.867 4.308 8.81.368.513.853.931 1.416 1.218Zm-2.357-14.2A5.912 5.912 0 0 1 12 4.635a5.912 5.912 0 0 1 5.905 5.905c0 1.508-1.42 4.295-3.996 7.85a2.358 2.358 0 0 1-3.818 0c-2.577-3.554-3.997-6.342-3.997-7.85a5.912 5.912 0 0 1 1.732-4.174Zm2.507 1.638a3 3 0 1 1 3.334 4.988 3 3 0 0 1-3.334-4.988Zm.834 3.741a1.5 1.5 0 1 0 1.667-2.495 1.5 1.5 0 0 0-1.667 2.495Z",
    fill: "#8CB3DC"
  })));
};
export default SvgLocationPin;